import React, { memo } from 'react'
import useWebsiteLoginSubmit from 'src/publisher/hooks/use-website-login-submit'
import { CommonPublisherButtonEntityOrSubEntity } from 'src/publisher/shared/components/button/common-publisher-button-entity-or-sub-entity'
import { WebsiteLoginButtonEntityInterface } from 'src/shared/entities/button/website-login-button.schema'

const TEST_ID = 'custom-login-button'

export interface WebsiteLoginButtonProps {
  entity: WebsiteLoginButtonEntityInterface
}

const WebsiteLoginButton = ({ entity }: WebsiteLoginButtonProps) => {
  const [isLoading, errors, submit] = useWebsiteLoginSubmit(entity)

  return (
    <CommonPublisherButtonEntityOrSubEntity
      entityOrSubEntity={entity}
      isLoading={isLoading}
      errors={errors}
      onClick={submit}
      testId={TEST_ID}
    />
  )
}

export default memo(WebsiteLoginButton)
